export default __webpack_public_path__ + "static/media/Girdle of the Endless Sands.a11b9988.jpg";